import React from 'react';
import { FormControl, Input, Modal, Text } from 'native-base';
import { useForm, Controller } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { i18nFn, useUpdateMember } from '@springbig/shared';
import { useToast } from '~/hooks/toast';
import { useGeneralStyles, useModalStyles } from '~/shared/styles';
import Button from '~/shared/Button';
import { Caption } from '~/shared/Typography';


const schema = yup.object().shape({
    firstName: yup.string().required('First name is required'),
    lastName: yup.string().required('Last name is required'),
});

interface FormData {
    firstName: string;
    lastName: string;
}

export default function ProfileCompleteName({ isOpen, onClose, t }: { isOpen: boolean, onClose: () => void, t: i18nFn; }) {
    const { control, handleSubmit, formState: { errors } } = useForm<FormData>({
        resolver: yupResolver(schema),
    });
    const gStyle = useGeneralStyles();
    const modalStyle = useModalStyles();

    const { mutate: updateMember } = useUpdateMember();
    const { successToast } = useToast();

    const onSubmit = (data: FormData) => {
        updateMember({
            member: {
                first_name: data.firstName,
                last_name: data.lastName,
            },
        });
        successToast(t('profile.profile_updated'));
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <Modal.Content>
                <Modal.CloseButton />
                <Modal.Header>
                    <Caption>{t('giftCard.nameCompletionFormTitle')}</Caption>
                </Modal.Header>
                <Modal.Body>
                    <FormControl isRequired isInvalid={'firstName' in errors}>
                        <FormControl.Label>{t('general.first_name')}</FormControl.Label>
                        <Controller
                            control={control}
                            name="firstName"
                            render={({ field: { onChange, onBlur, value } }) => (
                                <Input
                                    placeholder="John"
                                    onBlur={onBlur}
                                    onChangeText={onChange}
                                    value={value}
                                    borderColor={gStyle.button_background}
                                    _focus={{
                                        borderColor: gStyle.button_background,
                                    }}
                                />
                            )}
                        />
                        {errors.firstName && <Text color="red.500">{errors.firstName.message}</Text>}
                    </FormControl>
                    <FormControl mt={4} isRequired isInvalid={'lastName' in errors}>
                        <FormControl.Label>{t('general.last_name')}</FormControl.Label>
                        <Controller
                            control={control}
                            name="lastName"
                            render={({ field: { onChange, onBlur, value } }) => (
                                <Input
                                    placeholder="Doe"
                                    onBlur={onBlur}
                                    onChangeText={onChange}
                                    value={value}
                                    b borderColor={gStyle.button_background}
                                    _focus={{
                                        borderColor: gStyle.button_background,
                                    }}
                                />
                            )}
                        />
                        {errors.lastName && <Text color="red.500">{errors.lastName.message}</Text>}
                    </FormControl>
                </Modal.Body>
                <Modal.Footer justifyContent={'center'}>
                    <Button
                        bg={gStyle.button_background}
                        onPress={handleSubmit(onSubmit)}
                    >

                        <Caption color={gStyle.button_text}>{t('general.update')}</Caption>
                    </Button>
                </Modal.Footer>
            </Modal.Content>
        </Modal>
    );
}
